(function (ws) {
    'use strict';
    /**
     * @typedef {Object} Event - DOM Event object
     */
    ws.views.simpleTableClearFilterBtn = Backbone.View.extend({

        events: {
            'click #clearFilterBtn': 'clearSearch'
        },

        /**
         * Triggering an event for Clear Search
         * @param {Object} e
         */
        clearSearch: function (e) {
            if (this.$el.data('favorite') && parseInt($('#favoritesSize').val())) {
                this.eventAgg.trigger(this.$el.attr('id') + 'clearSearch', e, undefined, this.$el.data('favorite'));
            } else {
                this.eventAgg.trigger(this.$el.attr('id') + 'clearSearch', e);
            }

            if (isQuotingSite) {
                $('.sales-org').val($('.defaultSalesOrg').val());
            }
        }

    });
})(westcon);
